import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { useAddPopupMessage } from 'src/hooks/ui'
import { useEditProductTypeRequest } from 'src/hooks/api'
import { ProductTypeNewForm } from 'src/components/forms'

interface EditableProductTypeProps {
  id: number;
  name: string;
  onChange: () => void;
  onCancel: () => void;
}

export const EditableProductType: FC<EditableProductTypeProps> = ({
  id,
  name,
  onChange,
  onCancel,
}) => {
  const addMessage = useAddPopupMessage()
  const editProductTypeRequest = useEditProductTypeRequest({ id })

  const update = ({ displayName }: { displayName: string }) => {
    editProductTypeRequest.mutate(
      { name: displayName },
      {
        onSuccess: onChange,
        onError: (error) => addMessage({ type: 'error', text: error.message }),
      }
    )
  }

  return (
    <>
      <Grid item flexGrow={1}>
        <ProductTypeNewForm
          onSubmit={update}
          initialValues={{ displayName: name }}
          onCancel={onCancel}
        />
      </Grid>
    </>
  )
}